import gql from "graphql-tag";

import {gqlOp, type GqlOperation} from "@khan/data-gql-core";

import type {GetOneTimeUseMicrosoftLoginUrlMutationType} from "./__graphql-types__/index.ts";

export type {GetOneTimeUseMicrosoftLoginUrlMutationType} from "./__graphql-types__/index.ts";

export const GET_MICROSOFT_LOGIN_URL_MUTATION: GqlOperation<
    GetOneTimeUseMicrosoftLoginUrlMutationType["response"],
    GetOneTimeUseMicrosoftLoginUrlMutationType["variables"]
> = gqlOp(gql`
    mutation GetOneTimeUseMicrosoftLoginUrlMutation(
        $action: MicrosoftAuthAction!
        $continueUrl: String
        $role: UserRole
    ) {
        getOneTimeUseMicrosoftLoginUrl(
            action: $action
            continueUrl: $continueUrl
            role: $role
        ) {
            redirectUrl
            error {
                code
            }
        }
    }
`);
